import { db, ServerValue } from '@/firebase/db'
import { IOpcionMenuModel } from '@/store/types'

export default {
  findById: (data: any): Promise<any> =>
    new Promise((resolve) => {
      db.ref(`menu/${data.Id}`).once('value', (snapshot : any) => {
        resolve({ ...snapshot.val(), key: data.Id, Id: data.Id } as IOpcionMenuModel)
      })
    }),
  findAll: (): Promise<any> =>
    new Promise((resolve) => {
      db.ref(`menu`)
        .orderByChild('createdAt')
        .once('value', (snapshot : any) => {
          let _snapshot: any = []
          if (snapshot.val()) {
            _snapshot = Object.entries(snapshot.val()).map((e) => Object.assign(e[1], { key: e[0], Id: e[0] }))
          }
          resolve((_snapshot as unknown) as IOpcionMenuModel[])
        })
    }),
  save: (data: any): Promise<any> =>
    new Promise((resolve) => {
      if (data['key']) {
        db.ref(`menu/${data['key']}`).set({ ...data, updatedAt: ServerValue }, (snapshot: any) => {
          resolve(snapshot)
        })
      } else {
        db.ref(`menu`).push({ ...data, createdAt: ServerValue }, (snapshot: any) => {
          resolve(snapshot)
        })
      }
    })
}
